<template>
	<div class="page-box">
		<div class="title-box" v-if="rankData.name">
			<span>{{ rankData.name }}</span>
		</div>
		<div class="list-content" :class="rankData.name ? 'list-content1' : ''" v-if="rankData.listData && rankData.listData.length > 0">
			<div class="thead">
				<span></span>
				<span>建档人数</span>
				<span>签约人数</span>
				<span>老年人体检人数</span>
				<span>高血压随访人数</span>
				<span>高血压随访人次</span>
				<span>糖尿病随访人数</span>
				<span>糖尿病随访人次</span>
				<span>慢阻肺随访人数</span>
				<span>慢阻肺随访人次</span>
				<span>0-6岁周岁儿童管理数</span>
				<span>居民健康档案</span>
			</div>
			<div style="overflow: hidden">
				<vue-seamless-scroll :data="rankData.listData" :class-option="defaultOption">
					<div class="list-box">
						<div class="list" @click="toDetail(item)" v-for="(item, index) in rankData.listData" :key="index">
							<div :class="item.changelist && item.changelist.includes('icpname') ? 'redCol' : ''" class="item" :title="item.icpname">{{ item.icpname }}</div>
							<div :class="item.changelist && item.changelist.includes('jdnums') ? 'redCol' : ''" class="item">{{ item.jdnums }}</div>
							<div :class="item.changelist && item.changelist.includes('qynums') ? 'redCol' : ''" class="item">{{ item.qynums }}</div>
							<div :class="item.changelist && item.changelist.includes('oldtjnums') ? 'redCol' : ''" class="item">{{ item.oldtjnums }}</div>
							<div :class="item.changelist && item.changelist.includes('gxysfnums') ? 'redCol' : ''" class="item">{{ item.gxysfnums }}</div>
							<div :class="item.changelist && item.changelist.includes('gxysfcs') ? 'redCol' : ''" class="item">{{ item.gxysfcs || 0 }}</div>
							<div :class="item.changelist && item.changelist.includes('tnbsfnums') ? 'redCol' : ''" class="item">{{ item.tnbsfnums }}</div>
							<div :class="item.changelist && item.changelist.includes('tnbsfcs') ? 'redCol' : ''" class="item">{{ item.tnbsfcs || 0 }}</div>
							<div :class="item.changelist && item.changelist.includes('mzfsfnums') ? 'redCol' : ''" class="item">{{ item.mzfsfnums }}</div>
							<div :class="item.changelist && item.changelist.includes('mzfsfcs') ? 'redCol' : ''" class="item">{{ item.mzfsfcs || 0 }}</div>
							<div :class="item.changelist && item.changelist.includes('etnums') ? 'redCol' : ''" class="item">{{ item.etnums }}</div>
							<div class="item">
								<p :class="item.changelist && item.changelist.includes('dakfnums') ? 'redCol' : ''"><span>开放数：</span>{{ item.dakfnums }}</p>
								<p :class="item.changelist && item.changelist.includes('dadynums') ? 'redCol' : ''"><span>调阅数：</span>{{ item.dadynums }}</p>
							</div>
						</div>
					</div>
				</vue-seamless-scroll>
			</div>
		</div>
	</div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
	name: "rank",
	components: {
		vueSeamlessScroll,
	},
	props: {
		rankData: {
			type: Object,
			default: () => {},
		},
		isClick: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			isShowPop: false,
			cityInfo: {
				title: "",
				content: "",
			},
		};
	},
	// 监听属性 类似于data概念
	computed: {
		defaultOption() {
			return {
				step: 0.4, // 数值越大速度滚动越快
				limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
			};
		},
	},
	methods: {
		toDetail(row) {
			if (!this.isClick) {
				return;
			}
			this.$router.push({
				path: "/detail",
				query: { icpcode: row.icpcode },
			});
		},
	},
};
</script>
<style>
.redCol {
	color: #f56c6c !important;
}
</style>
<style scoped lang="stylus">
@font-face {
  font-family: "DIN";
  /* UnidreamLED.ttf在项目中的位置 */
  src: url("~@/assets/css/DIN Medium.ttf") format("truetype");
}
.page-box {
  width 100%
  height: 100%
  background-size: cover
  overflow: hidden;
  .title-box {
    width 211px
    height: 30px
    background: url(../assets/img/t3.png) no-repeat center bottom
    background-size: 100% 100%
    text-align: center
    margin: 0 auto
    span {
      font-family: Source Han Sans CN
      font-weight: bold
      font-size: 24px
      color: #FEFFFF
      line-height: 24px
      background: linear-gradient(0deg, #AAEAFA 0%, #FFFFFF 91.357421875%)
      -webkit-background-clip: text
      -webkit-text-fill-color: transparent
    }

  }
  // list-content
  .list-content {
    overflow hidden
    height: calc(100% - 0px);
    padding: 10px;
    &.list-content1{
      height: calc(100% -55px);
    }
    .thead{
      display: flex
      align-items: center
      padding: 0 5px
      span{
        box-sizing: border-box
        padding 0 15px 0 0
        width 69px
        display: inline-block
        word-break: break-all
        font-family: Source Han Sans CN
        font-weight: 400
        font-size: 12px
        color: #AAEAFA
        line-height: 16px
        &:first-child{
          width 120px
        }
        &:last-child{
          width 100px
        }
      }
    }
    .list-box {
      .list {
        display: flex
        width: 100%
        height: 56px
        background: linear-gradient(0deg, rgba(0, 67, 83, 1) 0%,rgba(0, 67, 83, 0) 100%)
        border-radius: 4px
        margin-bottom: 10px
        align-items: center
        cursor pointer
        padding: 0 5px
        .item{
          font-family: Source Han Sans CN
          font-weight: 400
          font-size: 14px
          color: #FFFFFF
          width 69px
          span {
            color: #00CBD1
          }
          &:nth-child(even){
            color: #AAEAFA
          }
          &:first-child{
            width 120px
            overflow hidden
            // text-overflow: ellipsis
            // white-space: normal
            // word-break: keep-all
          }
          &:last-child{
            width 100px
          }
        }
      }
    }
  }
}
</style>
